$('document').ready ->
  responsive =
    xs: 0
    sm: 544
    md: 768
    lg: 992
    xl: 1200

  # Initialize nanoscroller
  sidebar = $('.nano')
  if sidebar.length > 0
    sidebar.nanoScroller
      iOSNativeScrolling: true
    sidebar.addClass 'has-nano'
    sidebar_index = $('.active', sidebar).index()
    loop
      break if $('li', sidebar).eq(sidebar_index).hasClass('table-heading') || sidebar_index < 0
      sidebar_index -= 1
    sidebar_top = $('li', sidebar).eq(sidebar_index).offset().top - sidebar.offset().top - 40
    sidebar.nanoScroller scrollTop: sidebar_top

    # Toggle sidebar visibility
    $('#sidebar-toggle').on 'click', =>
      $('#sidebar').toggleClass 'sidebar-visible'
      return

    # Build or destroy nanoscroller responsively
    $(window).resize =>
      window_width = $(window).width()
      if window_width < responsive['md'] && sidebar.hasClass('has-nano')
        sidebar.removeClass 'has-nano'
        sidebar.nanoScroller
          destroy: true
        $('.nano-pane', sidebar).remove()
      else if window_width >= responsive['md'] && !sidebar.hasClass('has-nano')
        sidebar.addClass 'has-nano'
        sidebar.nanoScroller
          iOSNativeScrolling: true
      return
    .trigger('resize')


  # Initialize slidea in documentation
  #
  $('[data-reveal]').reveal()


  if $.fn.isotope
    $('#topics-section').isotope
      selector: '> div'

  # Change footer background on icon hover
  $('.social-icons a').each (index, icon) ->
    color_class = 'social-colored social-' + $(icon).attr('data-color')

    $(icon).on 'mouseenter', =>
      $('#social-section').addClass color_class
      return

    $(icon).on 'mouseleave', =>
      $('#social-section').removeClass color_class
      return
    return

  $('.folder-tree-view .folder').each (index, folder) =>
    folder = $(folder)
    label = $('> span', folder)
    icon = $('> i', label)

    return if folder.hasClass 'disabled'

    label.on 'click', (e) =>
      folder.toggleClass('open')
      icon.toggleClass('fa-folder fa-folder-open')
      return
    return

  return
